"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Characters = void 0;
const button_arrow_black_png_1 = __importDefault(require("../../img/button/button_arrow_black.png"));
const button_arrow_red_png_1 = __importDefault(require("../../img/button/button_arrow_red.png"));
const languageUtils_1 = require("../languageUtils");
const Characters_text_1 = require("./Characters_text");
const nova_decal_png_1 = __importDefault(require("../../img/characters/nova_decal.png"));
const nova_decal_webp_1 = __importDefault(require("../../img/characters/nova_decal.webp"));
const nova_voice1_f_wav_1 = __importDefault(require("../../img/characters/audio/nova_voice1_f.wav"));
const nova_voice2_f_wav_1 = __importDefault(require("../../img/characters/audio/nova_voice2_f.wav"));
const nova_voice1_m_wav_1 = __importDefault(require("../../img/characters/audio/nova_voice1_m.wav"));
const nova_voice2_m_wav_1 = __importDefault(require("../../img/characters/audio/nova_voice2_m.wav"));
class Characters {
    constructor() {
        this.canIClick = true;
        this.canIClickCharacter = true;
        this.voiceAudio = null;
        this.sections = Array.from(document.querySelectorAll('.characters__selection'));
        this.novaSection = document.getElementById('nova');
        this.reclaimersSection = document.getElementById('reclaimers');
        this.neunSection = document.getElementById('neun');
        this.etcSection = document.getElementById('etc');
        this.init();
    }
    init() {
        this.characterAffiliationButtonHandlers();
        const initialGroup = this.getInitialGroupFromURL();
        // Clear any previously active button
        const prevActive = document.querySelector('.characters__selector__active');
        if (prevActive) {
            prevActive.classList.remove('characters__selector__active');
            const prevBtn = prevActive.querySelector('.btn');
            const prevArrow = prevActive.querySelector('.btn__arrow');
            prevBtn?.classList.remove('btn--active');
            prevArrow?.setAttribute('src', button_arrow_black_png_1.default);
        }
        // Set new active button
        const initialBtn = document.querySelector(`.characters__selector__choice[data-characters="${initialGroup}"]`);
        if (initialBtn) {
            initialBtn.classList.add('characters__selector__active');
            const btn = initialBtn.querySelector('.btn');
            const arrow = initialBtn.querySelector('.btn__arrow');
            btn?.classList.add('btn--active');
            arrow?.setAttribute('src', button_arrow_red_png_1.default);
        }
        this.showCorrectCharactersSection(initialGroup);
        this.updateBackgroundImage(initialGroup);
        const currentParams = new URLSearchParams(window.location.search);
        const langParam = currentParams.get('lang');
        const newUrl = window.location.pathname + (langParam ? `?lang=${langParam}` : '');
        window.history.replaceState({}, '', newUrl);
        this.characterThumbsButtonHandler();
        this.setUpPageText();
        this.preloadCharacterImages();
        this.preloadBackgroundImages();
        this.novaSetup();
    }
    novaSetup() {
        const isWebp = document.documentElement.classList.contains('webp');
        const novaZoomBtn = document.querySelector('.characters__zoom__btn--nova');
        if (novaZoomBtn) {
            novaZoomBtn.setAttribute('data-src', isWebp ? nova_decal_webp_1.default : nova_decal_png_1.default);
        }
        const novaVoice1 = document.querySelector('#nova .voice__one');
        const novaVoice2 = document.querySelector('#nova .voice__two');
        const novaVoice3 = document.querySelector('#nova .voice__three');
        const novaVoice4 = document.querySelector('#nova .voice__four');
        if (novaVoice1) {
            novaVoice1.setAttribute('data-audio', nova_voice1_f_wav_1.default);
            novaVoice1.onclick = () => this.playVoiceAudio(nova_voice1_f_wav_1.default);
        }
        if (novaVoice2) {
            novaVoice2.setAttribute('data-audio', nova_voice2_f_wav_1.default);
            novaVoice2.onclick = () => this.playVoiceAudio(nova_voice2_f_wav_1.default);
        }
        if (novaVoice3) {
            novaVoice3.setAttribute('data-audio', nova_voice1_m_wav_1.default);
            novaVoice3.onclick = () => this.playVoiceAudio(nova_voice1_m_wav_1.default);
        }
        if (novaVoice4) {
            novaVoice4.setAttribute('data-audio', nova_voice2_m_wav_1.default);
            novaVoice4.onclick = () => this.playVoiceAudio(nova_voice2_m_wav_1.default);
        }
    }
    getInitialGroupFromURL() {
        const params = new URLSearchParams(window.location.search);
        const group = params.get('group');
        return ['reclaimers', 'neun', 'nova', 'etc'].includes(group)
            ? group
            : 'nova';
    }
    showCorrectCharactersSection(sectionId) {
        this.sections.forEach(section => section.classList.add('characters__hide'));
        let targetSection = null;
        let defaultCharacterKey;
        switch (sectionId) {
            case 'reclaimers':
                targetSection = this.reclaimersSection;
                defaultCharacterKey = 'raven';
                break;
            case 'neun':
                targetSection = this.neunSection;
                defaultCharacterKey = 'void';
                break;
            case 'etc':
                targetSection = this.etcSection;
                defaultCharacterKey = 'osteo';
                break;
            default:
                targetSection = this.novaSection;
                defaultCharacterKey = null;
        }
        targetSection?.classList.remove('characters__hide');
        this.canIClick = true;
        if (defaultCharacterKey)
            this.showCorrectCharacter(defaultCharacterKey);
        return targetSection;
    }
    characterAffiliationButtonHandlers() {
        const selectors = document.querySelectorAll('.characters__selector__choice');
        selectors.forEach(selector => {
            selector.addEventListener('click', e => {
                e.preventDefault();
                const target = e.target.closest('.characters__selector__choice');
                if (!target || !this.canIClick)
                    return;
                const section = target.getAttribute('data-characters');
                if (!section || section === 'inactive')
                    return;
                this.canIClick = false;
                document
                    .querySelector('.characters__selector__active .btn')
                    ?.classList.remove('btn--active');
                document
                    .querySelector('.characters__selector__active .btn__arrow')
                    ?.setAttribute('src', button_arrow_black_png_1.default);
                document
                    .querySelector('.characters__selector__active')
                    ?.classList.remove('characters__selector__active');
                target.classList.add('characters__selector__active');
                const activeBtn = target.querySelector('.btn');
                const activeArrow = target.querySelector('.btn__arrow');
                activeBtn?.classList.add('btn--active');
                activeArrow?.setAttribute('src', button_arrow_red_png_1.default);
                this.showCorrectCharactersSection(section);
                this.updateBackgroundImage(section);
            });
        });
    }
    characterThumbsButtonHandler() {
        document.querySelectorAll('.thumbs__container').forEach(container => {
            container.addEventListener('click', e => {
                e.preventDefault();
                const parent = e.target.closest('.thumbs__container');
                if (this.canIClickCharacter &&
                    parent &&
                    !parent.classList.contains('thumbs__container__active')) {
                    this.canIClickCharacter = false;
                    const activeSection = document.querySelector('.characters__selection:not(.characters__hide)');
                    const currentActive = activeSection?.querySelector('.thumbs__container__active');
                    currentActive?.classList.remove('thumbs__container__active');
                    parent.classList.add('thumbs__container__active');
                    const selected = parent.getAttribute('data-character');
                    if (selected && (0, languageUtils_1.isValidCharacter)(selected)) {
                        (0, languageUtils_1.setCharacter)(selected);
                        this.showCorrectCharacter(selected);
                    }
                    this.canIClickCharacter = true;
                }
            });
        });
    }
    showCorrectCharacter(character) {
        if (!(0, languageUtils_1.isValidCharacter)(character))
            return;
        // Update active class
        const allThumbs = document.querySelectorAll('.thumbs__container');
        allThumbs.forEach(thumb => {
            thumb.classList.remove('thumbs__container__active');
        });
        const activeThumb = document.querySelector(`.thumbs__container[data-character="${character}"]`);
        activeThumb?.classList.add('thumbs__container__active');
        const language = (0, languageUtils_1.getLanguage)();
        const currentCharacter = Characters_text_1.charactersText[language][character];
        const isWebp = document.documentElement.classList.contains('webp');
        const imgSrc = isWebp
            ? Characters_text_1.characterImages[character].image_decal_webp
            : Characters_text_1.characterImages[character].image_decal;
        const activeSection = document.querySelector('.characters__selection:not(.characters__hide)');
        if (!activeSection)
            return;
        const img = activeSection.querySelector('.characters__group__image');
        const textGroup = activeSection.querySelector('.characters__text__group');
        const quotes = activeSection.querySelector('.characters__quotes');
        const zoomBtn = activeSection.querySelector('.characters__zoom__btn');
        const nameText = activeSection.querySelector('.characters__name');
        const vaEng = activeSection.querySelector('.characters__text__group__va--eng');
        const vaJP = activeSection.querySelector('.characters__text__group__va--jp');
        const faction = activeSection.querySelector('.factionDescText');
        const arsenal = activeSection.querySelector('.arsenalDescText');
        const profile = activeSection.querySelector('.characters__profile');
        const q1n = activeSection.querySelector('.quote__one--name');
        const q1t = activeSection.querySelector('#quote__one p');
        const q2n = activeSection.querySelector('.quote__two--name');
        const q2t = activeSection.querySelector('#quote__two p');
        const q3n = activeSection.querySelector('.quote__three--name');
        const q3t = activeSection.querySelector('#quote__three p');
        // 🌸 Blossom-specific background override
        const currentSection = document
            .querySelector('.characters__selector__active')
            ?.getAttribute('data-characters');
        const changeLines = document.querySelectorAll('.characters__text__group__section');
        if (currentSection === 'etc') {
            if (character === 'blossom') {
                this.updateBackgroundImage(currentSection, 'reclaimers');
                changeLines.forEach(line => {
                    line.classList.remove('characters__text__group__section--neun');
                });
            }
            else {
                this.updateBackgroundImage(currentSection, 'neun');
                changeLines.forEach(line => {
                    line.classList.add('characters__text__group__section--neun');
                });
            }
        }
        else {
            this.updateBackgroundImage(currentSection);
        }
        // Image animation
        img.classList.remove('fade__in__right', 'fade__in__right--active');
        img.classList.add('fade__out__right');
        this.preloadImage(imgSrc)
            .then(loadedSrc => {
            setTimeout(() => {
                img.src = loadedSrc;
                img.classList.remove('fade__out__right');
                void img.offsetWidth;
                img.classList.add('fade__in__right');
                setTimeout(() => img.classList.add('fade__in__right--active'), 10);
            }, 300); // fade-out duration must match CSS
        })
            .catch(err => {
            console.error('Image failed to preload:', err);
        });
        if (zoomBtn) {
            zoomBtn.classList.remove('fade__in__up', 'fade__in__up--active');
            zoomBtn.classList.add('fade__out__up');
            setTimeout(() => {
                const zoomSrc = isWebp
                    ? Characters_text_1.characterImages[character].image_decal_centered_webp
                    : Characters_text_1.characterImages[character].image_decal_centered;
                zoomBtn.setAttribute('data-src', zoomSrc);
                zoomBtn.classList.remove('fade__out__up');
                void zoomBtn.offsetWidth; // force reflow to restart animation
                zoomBtn.classList.add('fade__in__up');
                setTimeout(() => zoomBtn.classList.add('fade__in__up--active'), 10);
            }, 500);
        }
        // Text animation
        textGroup.classList.remove('fade__in__left', 'fade__in__left--active');
        textGroup.classList.add('fade__out__left');
        setTimeout(() => {
            nameText && (nameText.textContent = currentCharacter.name);
            vaEng && (vaEng.innerHTML = currentCharacter.vaEng);
            vaJP && (vaJP.innerHTML = currentCharacter.vaJP);
            console.log(faction);
            if (faction) {
                if (character.toLowerCase() === 'blossom') {
                    faction.innerHTML = '';
                    faction.parentElement?.classList.add('characters__hide');
                }
                else if (currentCharacter.faction &&
                    currentCharacter.faction.trim()) {
                    faction.innerHTML = currentCharacter.faction;
                    faction.parentElement?.classList.remove('characters__hide');
                }
                else {
                    faction.innerHTML = '';
                    faction.parentElement?.classList.add('characters__hide');
                }
            }
            arsenal && (arsenal.innerHTML = currentCharacter.arsenal);
            profile && (profile.textContent = currentCharacter.profile);
            q1n && (q1n.textContent = currentCharacter.quoteOneName);
            q1t && (q1t.textContent = currentCharacter.quoteOneText);
            q2n && (q2n.textContent = currentCharacter.quoteTwoName);
            q2t && (q2t.textContent = currentCharacter.quoteTwoText);
            q3n && (q3n.textContent = currentCharacter.quoteThreeName);
            q3t && (q3t.textContent = currentCharacter.quoteThreeText);
            const q3Wrapper = activeSection.querySelector('#quote__three');
            if (q3Wrapper &&
                !currentCharacter.quoteThreeName?.trim() &&
                !currentCharacter.quoteThreeText?.trim()) {
                q3Wrapper.classList.add('characters__hide');
            }
            else {
                q3Wrapper?.classList.remove('characters__hide');
            }
            textGroup.classList.remove('fade__out__left');
            void textGroup.offsetWidth;
            textGroup.classList.add('fade__in__left');
            setTimeout(() => textGroup.classList.add('fade__in__left--active'), 10);
        }, 500);
        // Quotes animation
        quotes.classList.remove('fade__in__up', 'fade__in__up--active');
        quotes.classList.add('fade__out__up');
        setTimeout(() => {
            quotes.classList.remove('fade__out__up');
            void quotes.offsetWidth;
            quotes.classList.add('fade__in__up');
            setTimeout(() => quotes.classList.add('fade__in__up--active'), 10);
        }, 500);
        // Audio
        this.attachVoiceButtonHandlers(character, activeSection);
    }
    attachVoiceButtonHandlers(characterKey, container) {
        const voice1 = container.querySelector('.voice__one');
        const voice2 = container.querySelector('.voice__two');
        const audioData = Characters_text_1.characterAudioMap[characterKey];
        if (!audioData) {
            console.warn(`No audio mapping found for ${characterKey}`);
            return;
        }
        if (voice1) {
            voice1.setAttribute('data-audio', audioData.voice1);
            voice1.onclick = () => this.playVoiceAudio(audioData.voice1);
        }
        if (voice2) {
            voice2.setAttribute('data-audio', audioData.voice2);
            voice2.onclick = () => this.playVoiceAudio(audioData.voice2);
        }
    }
    playVoiceAudio(src) {
        if (this.voiceAudio) {
            this.voiceAudio.pause();
            this.voiceAudio.currentTime = 0;
        }
        this.voiceAudio = new Audio(src);
        this.voiceAudio
            .play()
            .catch(err => console.error('Audio play failed:', err));
    }
    setUpPageText() {
        const language = (0, languageUtils_1.getLanguage)();
        const content = Characters_text_1.characterPageText[language] || Characters_text_1.characterPageText['en'];
        const updateAll = (selector, value, toUpper = true) => {
            document.querySelectorAll(selector).forEach(el => {
                el.textContent = toUpper ? value.toUpperCase() : value;
            });
        };
        const upperBindings = {
            '.characterTitle': content.pageTitle,
            '#novaBtn h2': content.novaBtn,
            '#reclaimersBtn h2': content.reclaimersBtn,
            '#neunBtn h2': content.neunBtn,
            '#etcBtn h2': content.etcBtn,
            '.characters__text__group__name h4': content.name,
            '.characters__text__group__va h4': content.voiceactor,
            '.characters__text__group__voice h4': content.voiceTitle,
            '.characters__voice1': content.voiceOne,
            '.characters__voice2': content.voiceTwo,
            '.characters__voice3': content.voiceThree,
            '.characters__voice4': content.voiceFour,
            '.characters__text__group__arsenal h4': content.arsenal,
            '.characters__text__group__profile h4': content.profile,
            '.characterCreationText': content.creationTitle,
            '.nova__arsenal': content.novaArsenal,
        };
        if (content.faction?.trim()) {
            updateAll('.characters__text__group__faction h4', content.faction, true);
        }
        const normalBindings = {
            '.nova__quoteone': content.novaQuoteOne,
            '.nova__quotetwo': content.novaQuoteTwo,
            '.nova__quotethree': content.novaQuoteThree,
        };
        for (const selector in upperBindings) {
            updateAll(selector, upperBindings[selector], true);
        }
        for (const selector in normalBindings) {
            updateAll(selector, normalBindings[selector], false);
        }
        const el = document.querySelector('.charCreationDesc');
        if (el)
            el.innerHTML = content.creationDesc;
        const el2 = document.querySelector('.nova__profile');
        if (el2)
            el2.innerHTML = content.novaProfile;
        const el3 = document.querySelector('.nova__characters__text__group__va--eng');
        if (el3)
            el3.innerHTML = content.vaEN;
        const el4 = document.querySelector('.nova__characters__text__group__va--jp');
        if (el4)
            el4.innerHTML = content.vaJP;
    }
    updateBackgroundImage(affiliation, override) {
        const picture = document.querySelector('.characters__bg');
        if (!picture)
            return;
        const sources = picture.querySelectorAll('source');
        const fallbackImg = picture.querySelector('img');
        const bg = Characters_text_1.bgImages[override ?? affiliation]; // Use override if given
        sources.forEach(source => {
            const media = source.getAttribute('media') || '';
            const type = source.getAttribute('type');
            if (type === 'image/webp' && media.includes('640')) {
                source.setAttribute('srcset', bg.webp640);
            }
            else if (type === 'image/webp' && media.includes('1280')) {
                source.setAttribute('srcset', bg.webp1280);
            }
            else if (type === 'image/webp') {
                source.setAttribute('srcset', bg.webp1920);
            }
            else if (type === 'image/jpg' && media.includes('1280')) {
                source.setAttribute('srcset', bg.jpg1280);
            }
            else if (type === 'image/jpg') {
                source.setAttribute('srcset', bg.jpg1920);
            }
        });
        if (fallbackImg) {
            fallbackImg.setAttribute('src', bg.fallback);
        }
    }
    preloadCharacterImages() {
        const isWebp = document.documentElement.classList.contains('webp');
        Object.values(Characters_text_1.characterImages).forEach((imageSet) => {
            const img = new Image();
            img.src = isWebp ? imageSet.image_decal_webp : imageSet.image_decal;
            const zoomImg = new Image();
            zoomImg.src = isWebp
                ? imageSet.image_decal_centered_webp
                : imageSet.image_decal_centered;
        });
    }
    preloadBackgroundImages() {
        const isWebp = document.documentElement.classList.contains('webp');
        Object.values(Characters_text_1.bgImages).forEach(bg => {
            const preload = (src) => {
                const img = new Image();
                img.src = src;
            };
            if (isWebp) {
                preload(bg.webp640);
                preload(bg.webp1280);
                preload(bg.webp1920);
            }
            else {
                preload(bg.jpg1280);
                preload(bg.jpg1920);
            }
            preload(bg.fallback);
        });
    }
    preloadImage(src) {
        return new Promise((res, rej) => {
            const img = new Image();
            img.addEventListener('load', () => res(src));
            img.addEventListener('error', err => rej(err));
            img.src = src;
        });
    }
}
exports.Characters = Characters;
